import { t } from 'i18next'
import { GOAL_AD_COST } from '~/modules/retailMedia/constants/objectiveBased'
import { formatDate } from '~/helpers'

import { GoalValue } from './GoalValue'

export function getModalData({ formRef, selectedProducts }: GetModalDataProps) {
  const formData =
    formRef?.current?.getData() as CreateCampaignObjectiveBasedFormData

  function acosInterval() {
    const goal = formData?.goal
    const min = GOAL_AD_COST?.[goal]?.min
    const max = GOAL_AD_COST?.[goal]?.max

    if (!goal || !min || !max) return ''

    return `${min}% - ${max}%`
  }

  function getFormattedDate(dateString: string) {
    return formatDate(dateString, undefined, t('common:patterns.date'))
  }

  const modalData: { label: string; value: string | JSX.Element }[] = [
    {
      label: t('rm:campaignName'),
      value: String(formData?.name || '')
    },
    {
      label: t('rm:objectiveBased.strategy'),
      value: <GoalValue goal={formData?.goal} />
    },
    {
      label: t('rm:objectiveBased.acos'),
      value: String(acosInterval())
    },
    {
      label: t('rm:productAds'),
      value: t('rm:quantityProducts', {
        count: selectedProducts?.length || 0
      })
    },
    {
      label: t('rm:objectiveBased.setup.campaign.dailyBudget'),
      value: String(formData?.daily_budget?.value || '')
    },
    {
      label: t('rm:Date'),
      value: `${getFormattedDate(formData?.start_at)}  -  ${formData?.end_at ? getFormattedDate(formData.end_at) : t('rm:noEnd')}`
    }
  ]

  return modalData
}
